import React from 'react';
import { observer } from 'mobx-react';
import { PatientTemplateListTemplate } from 'themes/application/patient/pages';
import { setCurrentView } from 'core/utils';
import { PatientTemplateListViewStore } from 'application/patient/stores';

@setCurrentView((rootStore) => new PatientTemplateListViewStore(rootStore), 'listViewStore')
@observer
class PatientTemplateList extends React.Component {
    render() {
        return <PatientTemplateListTemplate {...this.props} />
    }
}

export default PatientTemplateList;